module.exports = __webpack_public_path__ + "static/exterior-2-aa6e5a8cb508f1a34ac0316f38c86046.jpg";